import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getData } from '@yme/api';
import { Carousel, HeaderCarouselDefault, useCarousel } from '@yme/atoms/carousel';
import { GridWrapper } from '@yme/atoms/grid';
import { useIsMount, useWindowSize } from '@yme/common/hooks';
import { CAROUSEL_CONFIG, GAP_BETWEEN_ITEMS_DESKTOP, GAP_BETWEEN_ITEMS_MOBILE, } from '@yme/components/Destinations/ExperienceRelatedExperiences/constants';
import { getDataForDestinationCard } from '@yme/components/Destinations/UnitRelatedExperience/helpers';
import { IndentWrapper } from '@yme/components/Separator';
import { DestinationCard } from '@yme/molecules/cards';
import { getIsInAuthor, getRootLang, getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { getAmbassadorDetailsPageState } from '../AmbassadorDetailsPage/redux/selectors';
import { buildRequestUrl } from './helpers';
export function AmbassadorRelatedExperiences({ experiencesRootPath, edpURL, isRemoveBottomIndent, }) {
    const [destinations, setDestinations] = useState([]);
    const { _path } = useSelector(getAmbassadorDetailsPageState);
    const language = useSelector(getRootLang);
    const isInAuthor = useSelector(getIsInAuthor);
    const isRightToLeft = useSelector(getRTL);
    const { activeItem, onClickPrevItem, onClickNextItem, indexOfCount, counts, setCounts } = useCarousel();
    const isMount = useIsMount();
    const { isInfiniteDesktopView, isMobileView } = useWindowSize();
    const { t } = useTranslation();
    useEffect(() => {
        if (isMount || !_path || !experiencesRootPath) {
            return;
        }
        const getAmbassadorRelateExperience = async () => {
            try {
                const response = await getData(buildRequestUrl(_path, experiencesRootPath));
                const data = response.data?.destinationList?.items ?? [];
                const destinationData = data.map((destination) => getDataForDestinationCard(destination, language, edpURL, isInAuthor));
                setDestinations(destinationData);
            }
            catch (error) { }
        };
        getAmbassadorRelateExperience();
    }, [_path, edpURL, experiencesRootPath, isInAuthor, isMount, language]);
    const commonCarouselProps = {
        titleCarousel: t('destinations_experienceRelatedExperiences_title'),
        isRightToLeft,
        activeItem,
        onClickPrevItem,
        onClickNextItem,
        indexOfCount,
        counts,
    };
    const arrowTitles = {
        titlePrev: t('common_previous_label'),
        titleNext: t('common_next_label'),
    };
    if (!_path || !experiencesRootPath || !destinations.length) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent, isRightToLeft: isRightToLeft },
        React.createElement(GridWrapper, null,
            React.createElement(HeaderCarouselDefault, { ...commonCarouselProps, arrowTitles: arrowTitles, isArrowNavigationVisible: true, isArrowNavigationVisibleOnTablet: true }),
            React.createElement(Carousel, { ...commonCarouselProps, carouselConfig: CAROUSEL_CONFIG, getterSize: isMobileView ? GAP_BETWEEN_ITEMS_MOBILE : GAP_BETWEEN_ITEMS_DESKTOP, items: destinations, isDotsPanelVisible: !isInfiniteDesktopView, ChildComponent: DestinationCard, setCounts: setCounts }))));
}
AmbassadorRelatedExperiences.displayName = 'AmbassadorRelatedExperiences_AEMComponent';
